// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2wWfP","insightsList":"newBusinessInsightsMenu_insightsList__352Jf","active":"newBusinessInsightsMenu_active__ivQpH"};